/**
 * Frontend Constants
 * 
 * This file contains constants used throughout the frontend application.
 * While most dropdown data should be fetched from the backend API,
 * these values serve as fallbacks in case API calls fail.
 */

// Transport mode options for deliveries
export const TRANSPORT_MODE_OPTIONS = [
  { value: 'vessel', label: 'Vessel' },
  { value: 'train', label: 'Train' },
  { value: 'truck', label: 'Truck' },
  { value: 'other', label: 'Other' }
];

// All employees options for deal maker freight
export const ALL_EMPLOYEES_OPTIONS = [
  { value: "Ameer Ajmal", label: "Ameer Ajmal" },
  { value: "Raghad Al-Rady", label: "Raghad Al-Rady" },
  { value: "Alrike Allameh", label: "Alrike Allameh" },
  { value: "Fitri Amalina", label: "Fitri Amalina" },
  { value: "Rifqi Arsad", label: "Rifqi Arsad" },
  { value: "Siddharth Banthia", label: "Siddharth Banthia" },
  { value: "Vikas Basendra", label: "Vikas Basendra" },
  { value: "Thomas Beerbower", label: "Thomas Beerbower" },
  { value: "Shawan Biswas", label: "Shawan Biswas" },
  { value: "Errin Brits-Slabbert", label: "Errin Brits-Slabbert" },
  { value: "Susan Buitendacht", label: "Susan Buitendacht" },
  { value: "Tribhuvan Dalmia", label: "Tribhuvan Dalmia" },
  { value: "Hieu Dinh Trong", label: "Hieu Dinh Trong" },
  { value: "Steffi Grabowski", label: "Steffi Grabowski" },
  { value: "Helen Grant", label: "Helen Grant" },
  { value: "Vitaliy Kareba", label: "Vitaliy Kareba" },
  { value: "Salma Hikmatul Khamila", label: "Salma Hikmatul Khamila" },
  { value: "Michael Kriebel", label: "Michael Kriebel" },
  { value: "Jens Moir", label: "Jens Moir" },
  { value: "Viviana Monroy", label: "Viviana Monroy" },
  { value: "Harald Müller", label: "Harald Müller" },
  { value: "Ndivhuho Nendouvhada", label: "Ndivhuho Nendouvhada" },
  { value: "Adrian Oestreich", label: "Adrian Oestreich" },
  { value: "Pawel Piprek", label: "Pawel Piprek" },
  { value: "Teresa Pretorius", label: "Teresa Pretorius" },
  { value: "Elisa Naomi Putri", label: "Elisa Naomi Putri" },
  { value: "Jung-Hae Ra", label: "Jung-Hae Ra" },
  { value: "Maria Reyes", label: "Maria Reyes" },
  { value: "Johannes Reyneke", label: "Johannes Reyneke" },
  { value: "Ana Roman", label: "Ana Roman" },
  { value: "Lars Schernikau", label: "Lars Schernikau" },
  { value: "Olga Schulze", label: "Olga Schulze" },
  { value: "Dennis Schwindt", label: "Dennis Schwindt" },
  { value: "Bhanu Singh", label: "Bhanu Singh" },
  { value: "Livio Spiegel", label: "Livio Spiegel" },
  { value: "Yana Starykova", label: "Yana Starykova" },
  { value: "Doreen Sternal", label: "Doreen Sternal" },
  { value: "Anastasia Strelnikova", label: "Anastasia Strelnikova" },
  { value: "Minyu Su", label: "Minyu Su" },
  { value: "Viktor Syrovatka", label: "Viktor Syrovatka" },
  { value: "Steffen Unger", label: "Steffen Unger" },
  { value: "Bertus Venter", label: "Bertus Venter" },
  { value: "Dina Yulianti", label: "Dina Yulianti" },
  { value: "Jonas Zukauskas", label: "Jonas Zukauskas" },
  { value: "Tanzeel Zulfiqar", label: "Tanzeel Zulfiqar" },
  { value: "Delmar Zulkifli", label: "Delmar Zulkifli" }
];

/**
 * Currency options for all currency dropdowns throughout the application
 * Major currencies are listed first, followed by others in alphabetical order
 */
export const CURRENCY_OPTIONS = [
  // Major currencies at the top for quick access
  { value: 'USD', label: 'USD - US Dollar' },
  { value: 'EUR', label: 'EUR - Euro' },
  { value: 'GBP', label: 'GBP - British Pound' },
  { value: 'JPY', label: 'JPY - Japanese Yen' },
  { value: 'CHF', label: 'CHF - Swiss Franc' },
  { value: 'CAD', label: 'CAD - Canadian Dollar' },
  { value: 'AUD', label: 'AUD - Australian Dollar' },
  { value: 'CNY', label: 'CNY - Chinese Renminbi Yuan' },
  { value: 'HKD', label: 'HKD - Hong Kong Dollar' },
  { value: 'SGD', label: 'SGD - Singapore Dollar' },
  
  // All other supported currencies in alphabetical order
  { value: 'AED', label: 'AED - UAE Dirham' },
  { value: 'BGN', label: 'BGN - Bulgarian Lev' },
  { value: 'BRL', label: 'BRL - Brazilian Real' },
  { value: 'CZK', label: 'CZK - Czech Koruna' },
  { value: 'DKK', label: 'DKK - Danish Krone' },
  { value: 'HUF', label: 'HUF - Hungarian Forint' },
  { value: 'IDR', label: 'IDR - Indonesian Rupiah' },
  { value: 'ILS', label: 'ILS - Israeli New Sheqel' },
  { value: 'INR', label: 'INR - Indian Rupee' },
  { value: 'ISK', label: 'ISK - Icelandic Króna' },
  { value: 'KRW', label: 'KRW - South Korean Won' },
  { value: 'MXN', label: 'MXN - Mexican Peso' },
  { value: 'MYR', label: 'MYR - Malaysian Ringgit' },
  { value: 'NOK', label: 'NOK - Norwegian Krone' },
  { value: 'NZD', label: 'NZD - New Zealand Dollar' },
  { value: 'PHP', label: 'PHP - Philippine Peso' },
  { value: 'PLN', label: 'PLN - Polish Złoty' },
  { value: 'RON', label: 'RON - Romanian Leu' },
  { value: 'SEK', label: 'SEK - Swedish Krona' },
  { value: 'THB', label: 'THB - Thai Baht' },
  { value: 'TRY', label: 'TRY - Turkish Lira' },
  { value: 'ZAR', label: 'ZAR - South African Rand' }
];

/**
 * Product category options for deliveries
 * Contains various coal types and other product categories
 */
export const PRODUCT_CATEGORY_OPTIONS = [
  { value: 'thermal_coal', label: 'Thermal Coal' },
  { value: 'steam_coal', label: 'Steam Coal' },
  { value: 'coking_coal', label: 'Coking Coal' },
  { value: 'anthracite_coal', label: 'Anthracite Coal' },
  { value: 'other_metallurgical_coal', label: 'Other Metallurgical Coal' },
  { value: 'sized_coal', label: 'Sized Coal' },
  { value: 'petcoke', label: 'Petcoke' },
  { value: 'ores_and_metals', label: 'Ores and Metals' },
  { value: 'liquid_fuels', label: 'Liquid Fuels' },
  { value: 'cementitious', label: 'Cementitious' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'other', label: 'Other' }
];

/**
 * Country options for origin and destination dropdowns
 * Comprehensive list of 195+ countries for uniformity across the system
 */
export const COUNTRY_OPTIONS = [
  { value: 'afghanistan', label: 'Afghanistan' },
  { value: 'albania', label: 'Albania' },
  { value: 'algeria', label: 'Algeria' },
  { value: 'andorra', label: 'Andorra' },
  { value: 'angola', label: 'Angola' },
  { value: 'antigua_and_barbuda', label: 'Antigua and Barbuda' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'armenia', label: 'Armenia' },
  { value: 'australia', label: 'Australia' },
  { value: 'austria', label: 'Austria' },
  { value: 'azerbaijan', label: 'Azerbaijan' },
  { value: 'bahamas', label: 'Bahamas' },
  { value: 'bahrain', label: 'Bahrain' },
  { value: 'bangladesh', label: 'Bangladesh' },
  { value: 'barbados', label: 'Barbados' },
  { value: 'belarus', label: 'Belarus' },
  { value: 'belgium', label: 'Belgium' },
  { value: 'belize', label: 'Belize' },
  { value: 'benin', label: 'Benin' },
  { value: 'bhutan', label: 'Bhutan' },
  { value: 'bolivia', label: 'Bolivia' },
  { value: 'bosnia_and_herzegovina', label: 'Bosnia and Herzegovina' },
  { value: 'botswana', label: 'Botswana' },
  { value: 'brazil', label: 'Brazil' },
  { value: 'brunei', label: 'Brunei' },
  { value: 'bulgaria', label: 'Bulgaria' },
  { value: 'burkina_faso', label: 'Burkina Faso' },
  { value: 'burundi', label: 'Burundi' },
  { value: 'cambodia', label: 'Cambodia' },
  { value: 'cameroon', label: 'Cameroon' },
  { value: 'canada', label: 'Canada' },
  { value: 'cape_verde', label: 'Cape Verde' },
  { value: 'central_african_republic', label: 'Central African Republic' },
  { value: 'chad', label: 'Chad' },
  { value: 'chile', label: 'Chile' },
  { value: 'china', label: 'China' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'comoros', label: 'Comoros' },
  { value: 'congo', label: 'Congo' },
  { value: 'costa_rica', label: 'Costa Rica' },
  { value: 'croatia', label: 'Croatia' },
  { value: 'cuba', label: 'Cuba' },
  { value: 'cyprus', label: 'Cyprus' },
  { value: 'czech_republic', label: 'Czech Republic' },
  { value: 'democratic_republic_of_the_congo', label: 'Democratic Republic of the Congo' },
  { value: 'denmark', label: 'Denmark' },
  { value: 'djibouti', label: 'Djibouti' },
  { value: 'dominica', label: 'Dominica' },
  { value: 'dominican_republic', label: 'Dominican Republic' },
  { value: 'east_timor', label: 'East Timor' },
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'egypt', label: 'Egypt' },
  { value: 'el_salvador', label: 'El Salvador' },
  { value: 'equatorial_guinea', label: 'Equatorial Guinea' },
  { value: 'eritrea', label: 'Eritrea' },
  { value: 'estonia', label: 'Estonia' },
  { value: 'eswatini', label: 'Eswatini' },
  { value: 'ethiopia', label: 'Ethiopia' },
  { value: 'fiji', label: 'Fiji' },
  { value: 'finland', label: 'Finland' },
  { value: 'france', label: 'France' },
  { value: 'gabon', label: 'Gabon' },
  { value: 'gambia', label: 'Gambia' },
  { value: 'georgia', label: 'Georgia' },
  { value: 'germany', label: 'Germany' },
  { value: 'ghana', label: 'Ghana' },
  { value: 'greece', label: 'Greece' },
  { value: 'grenada', label: 'Grenada' },
  { value: 'guatemala', label: 'Guatemala' },
  { value: 'guinea', label: 'Guinea' },
  { value: 'guinea-bissau', label: 'Guinea-Bissau' },
  { value: 'guyana', label: 'Guyana' },
  { value: 'haiti', label: 'Haiti' },
  { value: 'honduras', label: 'Honduras' },
  { value: 'hong_kong', label: 'Hong Kong' },
  { value: 'hungary', label: 'Hungary' },
  { value: 'iceland', label: 'Iceland' },
  { value: 'india', label: 'India' },
  { value: 'indonesia', label: 'Indonesia' },
  { value: 'iran', label: 'Iran' },
  { value: 'iraq', label: 'Iraq' },
  { value: 'ireland', label: 'Ireland' },
  { value: 'israel', label: 'Israel' },
  { value: 'italy', label: 'Italy' },
  { value: 'ivory_coast', label: 'Ivory Coast' },
  { value: 'jamaica', label: 'Jamaica' },
  { value: 'japan', label: 'Japan' },
  { value: 'jordan', label: 'Jordan' },
  { value: 'kazakhstan', label: 'Kazakhstan' },
  { value: 'kenya', label: 'Kenya' },
  { value: 'kiribati', label: 'Kiribati' },
  { value: 'kosovo', label: 'Kosovo' },
  { value: 'kuwait', label: 'Kuwait' },
  { value: 'kyrgyzstan', label: 'Kyrgyzstan' },
  { value: 'laos', label: 'Laos' },
  { value: 'latvia', label: 'Latvia' },
  { value: 'lebanon', label: 'Lebanon' },
  { value: 'lesotho', label: 'Lesotho' },
  { value: 'liberia', label: 'Liberia' },
  { value: 'libya', label: 'Libya' },
  { value: 'liechtenstein', label: 'Liechtenstein' },
  { value: 'lithuania', label: 'Lithuania' },
  { value: 'luxembourg', label: 'Luxembourg' },
  { value: 'madagascar', label: 'Madagascar' },
  { value: 'malawi', label: 'Malawi' },
  { value: 'malaysia', label: 'Malaysia' },
  { value: 'maldives', label: 'Maldives' },
  { value: 'mali', label: 'Mali' },
  { value: 'malta', label: 'Malta' },
  { value: 'marshall_islands', label: 'Marshall Islands' },
  { value: 'mauritania', label: 'Mauritania' },
  { value: 'mauritius', label: 'Mauritius' },
  { value: 'mexico', label: 'Mexico' },
  { value: 'micronesia', label: 'Micronesia' },
  { value: 'moldova', label: 'Moldova' },
  { value: 'monaco', label: 'Monaco' },
  { value: 'mongolia', label: 'Mongolia' },
  { value: 'montenegro', label: 'Montenegro' },
  { value: 'morocco', label: 'Morocco' },
  { value: 'mozambique', label: 'Mozambique' },
  { value: 'myanmar', label: 'Myanmar' },
  { value: 'namibia', label: 'Namibia' },
  { value: 'nauru', label: 'Nauru' },
  { value: 'nepal', label: 'Nepal' },
  { value: 'netherlands', label: 'Netherlands' },
  { value: 'new_zealand', label: 'New Zealand' },
  { value: 'nicaragua', label: 'Nicaragua' },
  { value: 'niger', label: 'Niger' },
  { value: 'nigeria', label: 'Nigeria' },
  { value: 'north_korea', label: 'North Korea' },
  { value: 'north_macedonia', label: 'North Macedonia' },
  { value: 'norway', label: 'Norway' },
  { value: 'oman', label: 'Oman' },
  { value: 'pakistan', label: 'Pakistan' },
  { value: 'palau', label: 'Palau' },
  { value: 'palestine', label: 'Palestine' },
  { value: 'panama', label: 'Panama' },
  { value: 'papua_new_guinea', label: 'Papua New Guinea' },
  { value: 'paraguay', label: 'Paraguay' },
  { value: 'peru', label: 'Peru' },
  { value: 'philippines', label: 'Philippines' },
  { value: 'poland', label: 'Poland' },
  { value: 'portugal', label: 'Portugal' },
  { value: 'qatar', label: 'Qatar' },
  { value: 'romania', label: 'Romania' },
  { value: 'russia', label: 'Russia' },
  { value: 'rwanda', label: 'Rwanda' },
  { value: 'saint_kitts_and_nevis', label: 'Saint Kitts and Nevis' },
  { value: 'saint_lucia', label: 'Saint Lucia' },
  { value: 'saint_vincent_and_the_grenadines', label: 'Saint Vincent and the Grenadines' },
  { value: 'samoa', label: 'Samoa' },
  { value: 'san_marino', label: 'San Marino' },
  { value: 'sao_tome_and_principe', label: 'Sao Tome and Principe' },
  { value: 'saudi_arabia', label: 'Saudi Arabia' },
  { value: 'senegal', label: 'Senegal' },
  { value: 'serbia', label: 'Serbia' },
  { value: 'seychelles', label: 'Seychelles' },
  { value: 'sierra_leone', label: 'Sierra Leone' },
  { value: 'singapore', label: 'Singapore' },
  { value: 'slovakia', label: 'Slovakia' },
  { value: 'slovenia', label: 'Slovenia' },
  { value: 'solomon_islands', label: 'Solomon Islands' },
  { value: 'somalia', label: 'Somalia' },
  { value: 'south_africa', label: 'South Africa' },
  { value: 'south_korea', label: 'South Korea' },
  { value: 'south_sudan', label: 'South Sudan' },
  { value: 'spain', label: 'Spain' },
  { value: 'sri_lanka', label: 'Sri Lanka' },
  { value: 'sudan', label: 'Sudan' },
  { value: 'suriname', label: 'Suriname' },
  { value: 'sweden', label: 'Sweden' },
  { value: 'switzerland', label: 'Switzerland' },
  { value: 'syria', label: 'Syria' },
  { value: 'taiwan', label: 'Taiwan' },
  { value: 'tajikistan', label: 'Tajikistan' },
  { value: 'tanzania', label: 'Tanzania' },
  { value: 'thailand', label: 'Thailand' },
  { value: 'togo', label: 'Togo' },
  { value: 'tonga', label: 'Tonga' },
  { value: 'trinidad_and_tobago', label: 'Trinidad and Tobago' },
  { value: 'tunisia', label: 'Tunisia' },
  { value: 'turkey', label: 'Turkey' },
  { value: 'turkmenistan', label: 'Turkmenistan' },
  { value: 'tuvalu', label: 'Tuvalu' },
  { value: 'uganda', label: 'Uganda' },
  { value: 'ukraine', label: 'Ukraine' },
  { value: 'united_arab_emirates', label: 'United Arab Emirates' },
  { value: 'united_kingdom', label: 'United Kingdom' },
  { value: 'united_states', label: 'United States' },
  { value: 'uruguay', label: 'Uruguay' },
  { value: 'uzbekistan', label: 'Uzbekistan' },
  { value: 'vanuatu', label: 'Vanuatu' },
  { value: 'vatican_city', label: 'Vatican City' },
  { value: 'venezuela', label: 'Venezuela' },
  { value: 'vietnam', label: 'Vietnam' },
  { value: 'yemen', label: 'Yemen' },
  { value: 'zambia', label: 'Zambia' },
  { value: 'zimbabwe', label: 'Zimbabwe' }
];

// Month options for dropdown fields that require month names
export const MONTH_OPTIONS = [
  { value: 'January', label: 'January' },
  { value: 'February', label: 'February' },
  { value: 'March', label: 'March' },
  { value: 'April', label: 'April' },
  { value: 'May', label: 'May' },
  { value: 'June', label: 'June' },
  { value: 'July', label: 'July' },
  { value: 'August', label: 'August' },
  { value: 'September', label: 'September' },
  { value: 'October', label: 'October' },
  { value: 'November', label: 'November' },
  { value: 'December', label: 'December' }
];

// Incoterms options for delivery forms
export const INCOTERMS_OPTIONS = [
  { value: 'FOB', label: 'FOB - Free On Board' },
  { value: 'CFR', label: 'CFR - Cost and Freight' },
  { value: 'CIF', label: 'CIF - Cost, Insurance and Freight' },
  { value: 'DAP', label: 'DAP - Delivered at Place' }
];

// Re-export all constants as a single object for convenience
export const ALL_CONSTANTS = {
  TRANSPORT_MODE_OPTIONS,
  ALL_EMPLOYEES_OPTIONS,
  CURRENCY_OPTIONS,
  PRODUCT_CATEGORY_OPTIONS,
  COUNTRY_OPTIONS,
  MONTH_OPTIONS,
  INCOTERMS_OPTIONS
};

export default ALL_CONSTANTS; 